// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'

const vuetify = createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: 
    {
      light: 
      {
        dark: false,
        colors: 
        {
          surface: '#F5F7FA',
          border: '#E9ECEF',
          borderInner: '#DEE2E6',
          primary: '#343A40',
          secondary: '#6C757D',
          tertiary: '#ADB5BD',
          messageBg: '#495057',
          messageText: '#F8F9FA',
          messageTime: '#ADB5BD',
          messageContainer: '#343A40'
        }
      },
      dark: 
      {
        dark: true,
        colors: 
        {
          surface: '#1E1E2D',
          border: '#2C2C3A',
          borderInner: '#3C3C4A',
          primary: '#383940',
          secondary: '#6C757D',
          tertiary: '#CED4DA',
          messageBg: '#495057',
          messageText: '#F8F9FA',
          messageTime: '#CED4DA',
          messageContainer: '#4A4F6A'
        }
      }
    }
  },
  defaults: {
    VApp: {
      class: 'v-application'
    }
  }
})

export default vuetify;
